import { render, staticRenderFns } from "./TokenManagementContractAddress.vue?vue&type=template&id=3149dd14&scoped=true&lang=pug"
import script from "./TokenManagementContractAddress.vue?vue&type=script&lang=ts"
export * from "./TokenManagementContractAddress.vue?vue&type=script&lang=ts"
import style0 from "./TokenManagementContractAddress.vue?vue&type=style&index=0&id=3149dd14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3149dd14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
